// extracted by mini-css-extract-plugin
export default {"tabWrapper":"tab_tabWrapper__ZjFB5"};